

































































import { Vue, Component } from 'vue-property-decorator';
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import TextField from "@/components/inputs/TextField.vue";
import EForm from "@/components/datatable/EForm.vue";
import Id from "@/components/inputs/Id.vue";
import Select61 from "@/components/inputs/Select61.vue";
import { store } from "@/store";

class Noter {
  id!: number;
  isim!: string;
  sehir_id!: number;
  sehir_isim!: string;
}

@Component({
  components: { Select61, Id, EForm, TextField, DeleteButton },
  computed: {
    store() {
      return store;
    },
  }
})
export default class Noterler extends Vue {
  noterDialog: boolean = false;
  noterAction: string = this.$store.state.icwApiUrl + 'admin/noter';
  noterData = new Noter();
  noterTitle: string = "";
  noterlerLoading: boolean = true;
  noterlerHeaders = [
    { text: "Id", value: "id" },
    { text: "Noter Adı", value: "isim" },
    { text: "Şehir", value: "sehir_isim" },
    { text: "İşlemler", value: "actions" }
  ];
  noterler: Noter[] = [];
  noterSearch: string = "";

  created() {
    this.loadNoterler();
  }

  async loadNoterler() {
    try {
      this.noterlerLoading = true;
      const response = await this.$http.get(this.$store.state.icwApiUrl + 'admin/noterler');
      // Şehir adı düz bir alana taşınıyor ki tablo aramasi şehir üzerinden de çalışsın.
      this.noterler = (response.data || []).map((item: any) => ({
        id: item.id,
        isim: item.isim,
        sehir_id: item.sehir_id,
        sehir_isim: item.sehir ? item.sehir.isim : ""
      }));
    } catch (e) {
      console.log('Hata:', e);
    } finally {
      this.noterlerLoading = false;
    }
  }

  handleNoterSuccess() {
    this.noterDialog = false;
    this.loadNoterler();
  }

  addNoter() {
    this.noterTitle = "Ekle";
    this.noterData = new Noter();
    this.noterAction = this.$store.state.icwApiUrl + 'admin/noter';
    this.noterDialog = true;
  }

  editNoter(item: Noter) {
    this.noterTitle = "Düzenle";
    this.noterData = { ...item } as Noter;
    this.noterAction = this.$store.state.icwApiUrl + 'admin/noter/' + item.id;
    this.noterDialog = true;
  }
}
